export const MODULES_FETCH_START = "MODULES_FETCH_START";
export const MODULES_FETCH_SUCCESS = "MODULES_FETCH_SUCCESS";
export const MODULES_FETCH_ERROR = "MODULES_FETCH_ERROR";
export const MODULE_SELECT = "MODULE_SELECT";
